<template>
  <div>
   <h2>AI AGENT</h2>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import VideoHandling from "@/mixins/VideoHandling";
import UploadImage from "@/mixins/UploadImage";
import moment from "moment";
import firebase from "firebase";

export default {
  name: "ManageTabCarePlan",
  mixins: [UploadImage, VideoHandling],
  components: {},
  props: {
    profile: {
      type: Object,
      default: () => {}
    },
    provider: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {},
  computed: {
    ...mapGetters({})
  },
  methods: {
    handleActivation() {
     if (!this.unsub){
       this.setUpSnapShot();
     }
    },
    setUpSnapShot() {
      //@ToDo =- move to store
      if (this.rootPathDoc) {
        const db = firebase.firestore();
        let docRef = db.doc(this.rootPathDoc);
        this.unsub = docRef.onSnapshot(snapshot => {
          this.listDataDoc = snapshot.data();
        });
      }
    }
  },
  data() {
    return {
      rootPathDoc: `providers/${this.provider.id}/lists/__careplans`,
      v2: false,
      listDataDoc: null,
      unsub: null,
    };
  }
};
</script>

<style lang="scss" scoped>
</style>